export default {
    namespaced: true,

    state: {
        client: {},
        benefits: {},
        benefits_requested: false,

        qualified_bond: {},
        qualified_bond_requested: false,

        age_range: {
            min: 18,
            max: 59,
        },

        banks: [],
        transactions: [],
        transfer_duties: [],
        attorney_fees_options: [],
        home_cover_options: [],
        life_cover_options: [],
        life_cover_types: [],
        attorney_options: [],
        prime_targets: [],
        advantage_options: [],
        will_options: [],

        terms: [],

        bondPercentage: 90,

        resources_loaded: false,
    },

    getters: {
        getClient(state) {
            return state.client;
        },
        getClientTargetInterestRate(state) {
            let target_interest_rate_id = state.client.target_interest_rate;
            let target_interest_rate_value = 0;

            state.prime_targets.forEach((item) => {
                if (item.id === target_interest_rate_id) {
                    target_interest_rate_value = item.value;
                }
            });

            return target_interest_rate_value;
        },
        getClientTargetInterestRateLabel(state) {
            let target_interest_rate_id = state.client.target_interest_rate;
            let target_interest_rate_label = '';

            state.prime_targets.forEach((item) => {
                if (item.id === target_interest_rate_id) {
                    target_interest_rate_label = item.label;
                }
            });

            return target_interest_rate_label;
        },
        getBenefits(state) {
            return state.benefits;
        },
        getBenefitsRequested(state) {
            return state.benefits_requested;
        },

        getQualifiedBond(state) {
            return state.qualified_bond;
        },
        getQualifiedBondRequested(state) {
            return state.qualified_bond_requested;
        },

        getAgeRange(state) {
            return state.age_range;
        },

        getBanks(state) {
            return state.banks;
        },
        getTransactions(state) {
            return state.transactions;
        },
        getTransferDuties(state) {
            return state.transfer_duties;
        },
        getAttorneyFeesOptions(state) {
            return state.attorney_fees_options;
        },
        getHomeCoverOptions(state) {
            return state.home_cover_options;
        },
        getLifeCoverOptions(state) {
            return state.life_cover_options;
        },
        getLifeCoverTypes(state) {
            return state.life_cover_types;
        },
        getAttorneyOptions(state) {
            return state.attorney_options;
        },
        getPrimeTargets(state) {
            return state.prime_targets;
        },
        getAdvantageOptions(state) {
            return state.advantage_options;
        },
        getWillOptions(state) {
            return state.will_options;
        },

        getTerms(state) {
            return state.terms;
        },

        getBondPercentage(state) {
            return state.bondPercentage;
        },

        getResourcesLoaded(state) {
            return state.resources_loaded;
        }
    },

    actions: {
        getResources(context) {
            return new Promise((resolve, reject) => {
                if (context.getters.getResourcesLoaded) {
                    resolve();
                    return false;
                }

                window.axios.post('/calculators/homeVantageResources')
                    .then((response) => {
                        context.commit('setBankingOptions', response.data.bank_options);
                        context.commit('setTransactionOptions', response.data.transaction_types);
                        context.commit('setTransferDutyOptions', response.data.transfer_duty_options);
                        context.commit('setAttorneyFeesOptions', response.data.attorney_fees_options);
                        context.commit('setHomeCoverOptions', response.data.home_cover_types);
                        context.commit('setLifeCoverTypes', response.data.life_cover_types);
                        context.commit('setLifeCoverOptions', response.data.life_cover_options);
                        context.commit('setAttorneyOptions', response.data.attorney_options);
                        context.commit('setPrimeTargetOptions', response.data.prime_targets);
                        context.commit('setAdvantageOptions', response.data.advantage_options);
                        context.commit('setWillOptions', response.data.will_options);

                        context.commit('setTerms', response.data.terms);

                        context.commit('setResourcesLoaded', true);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });

        },
        newQuote(context) {
            let defaultInterestRateId = 0;

            context.getters['getPrimeTargets'].forEach((item) => {
                if (item.default) {
                    defaultInterestRateId = item.id;
                }
            });

            const client = {
                age: 45,
                gender: '1',
                smoker: '1',
                bank: 1,
                education: 4,
                monthly_income: 100000,

                home_market_value: 4000000,
                required_bond: 3600000,
                type_of_transaction: 1,
                transfer_duty_payment: 1,
                attorney_fees: 1,
                attorney_fees_payment: 2,
                other_debts: 0,
                term: 240,

                home_owners_cover: 1,
                life_cover: 1,
                life_cover_kind: 2,

                target_interest_rate: defaultInterestRateId,
                attorney: 1,
                best_advantage: 1,
                require_will: 1,

                client_name: '',
                quote_name: ''
            };

            context.commit('setClient', client);
            context.commit('setBenefits', {});
            context.commit('setBenefitsRequested', false);

            this.commit('calculators/setQuoteId', null);
            this.commit('calculators/setClientRating', 1);
            this.dispatch('calculators/resetAll');
        },
        getBenefits(context, intermediaryId = null) {
            this.commit('calculators/setChecking', true);

            let client = Object.assign({}, context.getters.getClient);
            client.target_interest_rate = context.getters.getClientTargetInterestRate;

            window.axios.post('/calculators/homeVantageBenefits', {
                create_for_int: intermediaryId,
                client: client,
                quote_id: this.getters['calculators/getQuoteId'],
                current_step: this.getters['calculators/getCurrentStep'],
            })
                .then((response) => {
                    if (client.other_debts > response.data.benefits.bondAvailableForDebtConsolidations.value) {
                        client.other_debts = response.data.benefits.bondAvailableForDebtConsolidations.value;
                        context.commit('setClient', client);
                    }

                    if (typeof response.data.benefits !== 'undefined') {
                        context.commit('setBenefits', response.data.benefits);
                        context.commit('setBenefitsRequested', true);
                    }

                    if (typeof response.data.benefits.quoteId !== 'undefined') {
                        this.commit('calculators/setQuoteId', response.data.benefits.quoteId);
                    }

                    this.commit('calculators/setChecking', false);
                })
                .catch((error) => {
                    console.error(error);
                    this.commit('calculators/setChecking', false);
                });
        },
        getQualifiedBond(context) {
            this.commit('calculators/setChecking', true);

            window.axios.post('/calculators/homeVantageQualifiedBond', {
                monthly_income: context.getters.getClient.monthly_income,
            })
                .then((response) => {
                    if (typeof response.data.qualified !== 'undefined') {
                        context.commit('setQualifiedBond', response.data.qualified);
                        context.commit('setQualifiedBondRequested', true);
                    }

                    this.commit('calculators/setChecking', false);
                })
                .catch((error) => {
                    console.error(error);
                    this.commit('calculators/setChecking', false);
                });
        },
    },

    mutations: {
        setClient(state, client) {
            state.client = client;
        },
        setBenefits(state, benefits) {
            state.benefits = benefits;
        },
        setBenefitsRequested(state, boolean) {
            state.benefits_requested = boolean;
        },

        setQualifiedBond(state, bond) {
            state.qualified_bond = bond;
        },
        setQualifiedBondRequested(state, boolean) {
            state.qualified_bond_requested = boolean;
        },

        setMaxAge(state, max) {
            state.age_range.max = max;
        },
        setMinAge(state, min) {
            state.age_range.min = min;
        },

        setBankingOptions(state, options) {
            state.banks = options;
        },
        setTransactionOptions(state, options) {
            state.transactions = options;
        },
        setTransferDutyOptions(state, options) {
            state.transfer_duties = options;
        },
        setAttorneyFeesOptions(state, options) {
            state.attorney_fees_options = options;
        },
        setHomeCoverOptions(state, options) {
            state.home_cover_options = options;
        },
        setLifeCoverOptions(state, options) {
            state.life_cover_options = options;
        },
        setLifeCoverTypes(state, options) {
            state.life_cover_types = options;
        },
        setAttorneyOptions(state, options) {
            state.attorney_options = options;
        },
        setPrimeTargetOptions(state, options) {
            state.prime_targets = options;
        },
        setAdvantageOptions(state, options) {
            state.advantage_options = options;
        },
        setWillOptions(state, options) {
            state.will_options = options;
        },

        setTerms(state, options) {
            state.terms = options;
        },

        setBondPercentage(state, percentage) {
            state.bondPercentage = percentage;
        },

        setResourcesLoaded(state, boolean) {
            state.resources_loaded = boolean;
        }
    }
}
